<template>
  <div class="base_main bg-contain common-blue-contain configure">
    <div class="breadcrumb-tilte">{{ $t('deviceManagement') }} > {{ $t('CommunicationConfiguration') }}</div>
    <div class="common-table-cnt common-aside-cnt-top">
      <div class="common-aside">
        <div class="serachLine">
          <el-input :placeholder="$t('organizationName')" clearable v-model="searchOrgName"> </el-input>
          <el-button type="primary" class="serachBtn">
            {{ $t('searchM') }}
          </el-button>
        </div>
        <el-tree
          :data="mechanismData"
          :props="defaultProps"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          :current-node-key="defaultId"
          :highlight-current="true"
          :filter-node-method="filterTreeNode"
          ref="dataConfigTree"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <span class="node-txt">{{ node.data.name }}</span>
          </span>
        </el-tree>
      </div>
      <div class="common-aside-main" style="right:15px;">
        <div class="main">
          <div class="search search-container view-info common-blue-tabs">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane :label="$t('setUp') + $t('wifiHotspot')" name="wifi"></el-tab-pane>
              <!-- <el-tab-pane label="安全帽通讯录" name="mailList"></el-tab-pane> -->
              <!-- <el-tab-pane label="频道信息" name="channel"></el-tab-pane> -->
              <el-tab-pane :label="$t('bluetoothPermissionSettings')" name="permissions"> </el-tab-pane>
            </el-tabs>
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
              <el-form-item :label="$t('permissionName')" v-if="activeName === 'permissions'">
                <el-input v-model="formInline.permissionsName" clearable :placeholder="$t('permissionName')"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button
                  type="primary"
                  class="serachBtn"
                  v-if="activeName === 'permissions'"
                  @click="searchPermission"
                  >{{ $t('query') }}</el-button
                >
                <el-button
                  type="primary"
                  class="add-btn"
                  v-if="activeName !== 'channel'"
                  @click="addHelmet(activeName)"
                  >{{ $t('newlyAded') }}</el-button
                >
                <el-button
                  type="primary"
                  class="add-btn"
                  v-if="activeName === 'channel' && tableData.length === 0"
                  @click="addHelmet(activeName)"
                  >{{ $t('newlyAded') }}</el-button
                >
                <el-button
                  type="primary"
                  class="add-btn"
                  v-if="activeName === 'channel'"
                  @click="checkAllInfo(activeName)"
                  >{{ $t('allChannelInformation') }}</el-button
                >
                <el-button
                  type="primary"
                  class="add-btn"
                  v-if="activeName === 'permissions' && loginIsAdmin == '1'"
                  @click="checkAllInfo(activeName)"
                  >{{ $t('allPermissionInfo') }}</el-button
                >
                <el-tooltip class="item" effect="dark" placement="bottom">
                  <div slot="content">
                    <div v-if="activeName === 'wifi'">
                      <p>1. {{ $t('configuredToRealize') }}</p>
                      <p>2. {{ $t('smartSafetyHelmet') }}</p>
                    </div>
                    <div v-if="activeName === 'mailList'">
                      <p>1. {{ $t('addressBookConfigured') }}</p>
                      <p>* {{ $t('safetyHelmetUses') }}</p>
                    </div>
                    <div v-if="activeName === 'permissions'">
                      <p>1. {{ $t('bluetoothPermission') }}</p>
                      <p v-if="loginIsAdmin == '1'">2. {{ $t('viewallPermissionInfo') }}</p>
                    </div>
                  </div>
                  <el-button type="primary" class="add-btn"><i class="help_icon"></i>{{ $t('help') }}</el-button>
                </el-tooltip>
              </el-form-item>
            </el-form>
          </div>
          <Table
            :data="tableData"
            :columns="columns"
            :tableHeight="595"
            :operation="dateOperation"
            @operate="operationEvent"
            :operationWidth="120"
            @sortChange="handleSort"
          ></Table>
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalData"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogHelmet"
      width="500px"
      class="common-blue-contain"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-form :model="fromData">
        <div class="settingDialog">
          <!-- wifi热点表单 -->
          <div class="wifiDialog" v-if="activeName === 'wifi'">
            <el-form-item :label="$t('wifiHotspot')" :label-width="formLabelWidth" :required="true">
              <el-input
                v-model="fromData.id"
                autocomplete="off"
                :placeholder="$t('wifiHotspot')"
                clearable
                :disabled="isEdit"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('priority')" :label-width="formLabelWidth" :required="true">
              <el-select v-model="fromData.priorityDesc" clearable :popper-append-to-body="false">
                <el-option v-for="item of priority" :label="item.label" :value="item.value" :key="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('passwordM')" :label-width="formLabelWidth">
              <el-input
                v-model="fromData.password"
                autocomplete="off"
                :placeholder="$t('passwordM')"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('remarks')" :label-width="formLabelWidth">
              <el-input
                v-model="fromData.description"
                autocomplete="off"
                :placeholder="$t('remarks')"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <!-- 通讯录表单 -->
          <div class="mailList-dialog" v-if="activeName === 'mailList'">
            <el-form-item :label="$t('contactName')" :label-width="formLabelWidth" :required="true">
              <el-input
                v-model="fromData.name"
                autocomplete="off"
                :placeholder="$t('contactName')"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('telephoneNumber')" :label-width="formLabelWidth" :required="true">
              <el-input
                v-model="fromData.phoneNumber"
                autocomplete="off"
                :placeholder="$t('telephoneNumber')"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <!-- 频道信息表单 -->
          <div class="channel-dialog" v-if="activeName === 'channel'">
            <el-form-item :label="$t('channelName')" :label-width="formLabelWidth" :required="true">
              <el-select v-model="fromData.selectedChannel" :popper-append-to-body="false">
                <el-option :label="$t('noChannelsAvailable')" value="1"></el-option>
                <el-option
                  v-for="item of channelOptions"
                  :label="item.channelName"
                  :value="item.channelId"
                  :key="item.channelId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- 权限信息表单 -->
          <div class="permissions-dialog" v-if="activeName === 'permissions'">
            <el-form-item :label="$t('permissionName')" :label-width="formLabelWidth" :required="true">
              <el-select
                v-model="fromData.helmetPermissions"
                clearable
                :placeholder="$t('peaseSelect')"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item of helmetPermissOption"
                  :label="item.permissionsName"
                  :value="item.permissionsId"
                  :key="item.permissionsId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitHelmet(activeName)">{{ $t('determine') }}</el-button>
        <el-button @click="dialogHelmet = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Table from '@/components/NewTable'
import { getOus } from '@/api/UserList'
import { errorMessage, success } from '@/util/common'
import {
  getWifiNetwork,
  addWifiNetwork,
  editWifiNetwork,
  deleteWifiNetwork,
  getContact,
  addContact,
  deleteContact,
  getChannelList,
  addOuChannel,
  deleteOuChannel,
  getChannels,
  getOuHelmetPermiss,
  addOuHelmetPermiss,
  getHelmetPermissions,
  editOuHelmetPermiss,
  deleteOuHelmetPermiss,
} from '@/api/setting'
import { isPoneAvailable } from '@/api/common'
import { errorCollection } from '@/api/dmp/dmpCollection'
export default {
  data() {
    return {
      loginIsAdmin: sessionStorage.getItem('isAdmin'),
      formInline: {
        permissionsName: '',
      },
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
      dialogHelmet: false,
      fromData: {
        // 表单字段
        id: '',
        channelName: '',
        password: '',
        description: '',
        priorityDesc: '',
        name: '',
        phoneNumber: '',
        selectedChannel: '1',
        helmetPermissions: '',
      },
      formLabelWidth: '160px',
      // 结构树的数据
      mechanismData: [],
      // 结构树数据值绑定方式
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      // 当前选中tab active的name
      activeName: 'wifi',
      // 左边结构树搜索绑定值
      searchOrgName: '',
      // wifi新增/编辑优先级 下拉选择
      priority: [
        { label: this.$t('priorityHigh'), value: '1' },
        { label: this.$t('priorityMid'), value: '2' },
        { label: this.$t('priorityLow'), value: '3' },
      ],
      // 频道新增/编辑：频道名称的下拉选择数据
      channelOptions: [],
      // 新增/编辑的弹窗标题
      dialogTitle: '',
      // 当前选中机构的数据
      currentTreeKey: [],
      // 编辑联系人当前的id
      mailIds: '',
      // 权限：新增/编辑时‘权限名称’的下拉选择数据
      helmetPermissOption: [],
      // 作用于默认选择/当前结构树的第一个的id
      defaultId: '',
      isEdit: false,
    }
  },
  components: {
    Table,
  },
  watch: {
    // 机构树搜索名字监听
    searchOrgName(val) {
      this.$refs.dataConfigTree.filter(val)
    },
  },
  methods: {
    // 排序
    handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.column.sortable
      this.formInline.useAsc = data.order=== "descending" ? 0 : 1
      this.currentPage = 1
      this.changePage()
    },
    // 点击‘查看所有频道信息’，查看所有权限信息 去到相应页面
    checkAllInfo(type) {
      if (type === 'channel') {
        this.$router.push({ path: 'channel' })
      } else {
        this.$router.push({ path: '/newIndex/newSet/helmet_permissions' })
      }
    },
    // 节点过滤
    filterTreeNode(value, data) {
      console.log(value, data)
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 弹窗点击确定，去到相应的接口提交
    submitHelmet(type) {
      if (type === 'wifi') {
        this.submitWifi()
      } else if (type === 'mailList') {
        this.subMailList()
      } else if (type === 'channel') {
        this.submitChannel()
      } else {
        this.submitOuHelmetPermiss()
      }
    },
    // 提交新增/编辑WiFi热点 表单
    submitWifi() {
      // NOSONAR
      let param = {
        id: this.fromData.id,
        description: this.fromData.description,
        ouId: this.currentTreeKey.id,
        password: this.fromData.password,
        priority: this.fromData.priorityDesc,
      }
      if (this.fromData.id === '') {
        errorCollection('设置》通信配置', '提交新增/编辑WiFi热点', {
          status: 200,
          data: { state: -1, msg: '请输入wifi热点' },
        })
        errorMessage(this.$t('pleaseEnter') + this.$t('wifiHotspot'))
        return
      } else if (this.fromData.id.indexOf('[') !== -1 || this.fromData.id.indexOf(']') !== -1) {
        errorCollection('通信配置', '提交新增/编辑WiFi热点', {
          status: 200,
          data: { state: -1, msg: 'wifi热点不包含‘[’或‘]’!' },
        })
        errorMessage('wifi热点不包含‘[’或‘]’!')
        return
      } else if (this.fromData.priorityDesc === '') {
        errorCollection('设置》通信配置', '提交新增/编辑WiFi热点', {
          status: 200,
          data: { state: -1, msg: '请选择优先级' },
        })
        errorMessage(this.$t('peaseSelect') + this.$t('priority'))
        return
      } else {
        if (this.isEdit) {
          param['indexId'] = this.fromData.indexId
          editWifiNetwork(param).then(res => {
            if (res.state === 0) {
              success(this.$t('saveSucesss'))
              this._getWifiNetwork()
              this.dialogHelmet = false
            }
          })
        } else {
          addWifiNetwork(param).then(res => {
            if (res.state === 0) {
              success(this.$t('saveSucesss'))
              this._getWifiNetwork()
              this.dialogHelmet = false
            }
          })
        }
      }
    },
    // 提交新增/编辑通讯录 表单
    subMailList() {
      let param = {
        id: this.mailIds,
        name: this.fromData.name,
        ouId: this.currentTreeKey.id,
        phoneNumber: this.fromData.phoneNumber,
      }
      if (this.fromData.name === '') {
        errorCollection('设置》通信配置', '新增/编辑通讯录', {
          status: 200,
          data: { state: -1, msg: '请输入联系人姓名' },
        })
        errorMessage(this.$t('pleaseEnter') + this.$t('contactName'))
        return
      } else if (this.fromData.phoneNumber === '') {
        errorCollection('设置》通信配置', '新增/编辑通讯录', {
          status: 200,
          data: { state: -1, msg: '请输入电话号码' },
        })
        errorMessage(this.$t('pleaseEnter') + this.$t('telephoneNumber'))
        return
      } else if (!isPoneAvailable(this.fromData.phoneNumber)) {
        // 验证电话号码
        errorCollection('设置》通信配置', '新增/编辑通讯录', {
          status: 200,
          data: { state: -1, msg: '请输入正确电话号码' },
        })
        errorMessage(this.$t('pleaseEnter') + this.$t('correctphonenumber'))
        return
      } else {
        addContact(param).then(res => {
          if (res.state === 0) {
            this._getContact()
            this.dialogHelmet = false
          }
        })
      }
    },
    // 提交新增频道 表单
    submitChannel() {
      let param = {
        channelId: this.fromData.selectedChannel,
        ouId: this.currentTreeKey.id,
      }
      if (this.fromData.selectedChannel === '1') {
        errorCollection('设置》通信配置', '新增频道', { status: 200, data: { state: -1, msg: '请选择频道' } })
        errorMessage(this.$t('peaseSelect') + this.$t('channel'))
        return
      } else {
        addOuChannel(param).then(res => {
          if (res.state === 0) {
            this._getChannelList()
            this.dialogHelmet = false
          }
        })
      }
    },
    // 提交新增机构头盔权限信息表单
    submitOuHelmetPermiss() {
      let param = {
        ouId: this.currentTreeKey.id,
        permissionsId: this.fromData.helmetPermissions,
        permissionsStatus: 0,
      }
      if (this.fromData.helmetPermissions === '') {
        errorCollection('设置》通信配置', '新增机构安全帽权限信息', {
          status: 200,
          data: { state: -1, msg: '请选择权限名称' },
        })
        errorMessage(this.$t('peaseSelect') + this.$t('permissionName'))
        return
      } else {
        addOuHelmetPermiss(param).then(res => {
          if (res.state === 0) {
            this._getOuHelmetPermiss()
            this.dialogHelmet = false
          }
        })
      }
    },
    // 点击tab
    handleClick(tab) {
      this.currentPage = 1
      this.pageSize = 10
      this.tableData = []
      // tab 为wifi 时的配置
      if (this.activeName === 'wifi') {
        this.basicConfig()
        this._getWifiNetwork()
      } else if (this.activeName === 'mailList') {
        // tab 为通讯录 时的配置
        this.columns = [
          {
            attrName: 'name',
            label: this.$t('contactName'),
          },
          {
            attrName: 'phoneNumber',
            label: this.$t('telephoneNumber'),
          },
        ]

        this.dateOperation = [
          {
            operateName: this.$t('edit'),
            type: 'edit',
            IsHad: '',
            class: 'editClick',
          },
          {
            operateName: this.$t('delete'),
            type: 'delect',
            IsHad: '',
            class: 'editClick',
          },
        ]
        this._getContact()
      } else if (this.activeName === 'channel') {
        // tab 为频道信息 时的配置
        this.columns = [
          {
            attrName: 'channelId',
            label: this.$t('channelCoding'),
          },
          {
            attrName: 'channelName',
            label: this.$t('channelName'),
          },
          {
            attrName: 'hertz',
            label: this.$t('frequency'),
          },
        ]
        this.dateOperation = [
          {
            operateName: this.$t('delete'),
            type: 'delect',
            IsHad: '',
            class: 'editClick',
          },
        ]
        this._getChannelList()
      } else {
        // tab 为蓝牙权限信息 时的配置
        this.columns = [
          {
            attrName: 'permissionsId',
            label: this.$t('permissionCode'),
            sort: 'permissionsId',
          },
          {
            attrName: 'permissionsName',
            label: this.$t('permissionName'),
            sort: 'permissionsName',
          },
          {
            attrName: 'statusFmt',
            label: this.$t('permissionstatus'),
            i18n: true,
            width: '160',
            align: 'center',
            sort: 'statusFmt',
          },
          {
            attrName: 'description',
            label: this.$t('remarks'),
            sort: 'description',
          },
        ]
        this.dateOperation = [
          {
            operateName: this.$t('switch'),
            type: 'status',
            IsHad: '',
            class: 'editClick',
          },
          {
            operateName: this.$t('delete'),
            type: 'delect',
            IsHad: '',
            class: 'editClick',
          },
        ]
        this._getOuHelmetPermiss()
      }
    },
    // 点击新增
    addHelmet(type) {
      this.isEdit = false
      this.fromData = {
        id: '',
        channelName: '',
        password: '',
        description: '',
        priorityDesc: '',
        name: '',
        phoneNumber: '',
        selectedChannel: '1',
        helmetPermissions: '',
      }
      switch (
        type // 根据当前activeName显示表单
      ) {
        case 'wifi':
          this.dialogTitle = this.$t('newlyAded') + this.$t('newWIFIHotspotInfo')
          break
        case 'mailList':
          this.mailIds = ''
          this.dialogTitle = this.$t('newlyAded') + this.$t('newContactInformation')
          break
        case 'channel':
          this._getChannels()
          this.dialogTitle = this.$t('newlyAded') + this.$t('channelInformation')
          break
        default:
          this._getHelmetPermissions()
          this.dialogTitle = this.$t('newlyAded') + this.$t('helmetPermission')
          break
      }
      this.dialogHelmet = true // 显示弹窗
    },
    operationEvent(type, value, index) {
      // 子组件返回触发的按钮操作事件
      if (type.type === 'edit') {
        // 编辑时触发事件
        this.editHelmetInfo(type.value)
      } else if (type.type === 'delect') {
        // 删除是触发事件
        this.delectInfo(type.value)
      } else {
        // 更改状态是触发
        this.changeStatus(type.value)
      }
    },
    // 点击更改权限使用状态
    changeStatus(row) {
      var permissStatus = null
      permissStatus = row.permissionsStatus === 1 ? 1 : 0
      this.$confirm(this.$t('updateAssigned'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let param = {
          ouId: row.ouId,
          permissionsId: row.permissionsId,
          permissionsStatus: permissStatus,
        }
        editOuHelmetPermiss(param).then(res => {
          if (res.state === 0) {
            this._getOuHelmetPermiss()
          }
        })
      })
    },
    // 点击编辑后根据activeName 显示不同表单信息
    editHelmetInfo(row) {
      this.isEdit = true
      switch (this.activeName) {
        case 'wifi':
          this.dialogTitle = this.$t('edit') + this.$t('newWIFIHotspotInfo')
          this.fromData = Object.assign({}, row)
          this.fromData.priorityDesc = row.priority + ''
          break
        case 'mailList':
          this.fromData = Object.assign({}, row)
          this.mailIds = row.id
          this.dialogTitle = this.$t('edit') + this.$t('newContactInformation')
          break
        case 'channel':
          this.dialogTitle = this.$t('edit') + this.$t('channelInformation')
          break
        default:
          this.dialogTitle = this.$t('edit') + this.$t('helmetPermission')
          break
      }
      this.dialogHelmet = true
    },
    // 点击删除后根据activeName ，请求响应接口事件
    delectInfo(row) {
      this.$confirm(this.$t('deleteThisInformation'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        if (this.activeName === 'wifi') {
          this._deleteWifiNetwork(row)
        } else if (this.activeName === 'mailList') {
          this._deleteContact(row)
        } else if (this.activeName === 'channel') {
          this._deleteOuChannel(row)
        } else {
          this._deleteOuHelmetPermiss(row)
        }
      })
    },
    // 点击删除WiFi热点
    _deleteWifiNetwork(row) {
      let param = {
        indexId: row.indexId,
        ouId: row.ouId,
      }
      deleteWifiNetwork(param).then(res => {
        if (res.state === 0) {
          success(this.$t('deleteSuccess'))
          this._getWifiNetwork()
        }
      })
    },
    // 点击删除联系方式
    _deleteContact(row) {
      let param = {
        id: row.id,
      }
      deleteContact(param).then(res => {
        if (res.state === 0) {
          success(this.$t('deleteSuccess'))
          this._getContact()
        }
      })
    },
    // 点击删除机构频道关联
    _deleteOuChannel(row) {
      let param = {
        channelId: row.channelId,
        ouId: this.currentTreeKey.id,
      }
      deleteOuChannel(param).then(res => {
        if (res.state === 0) {
          success(this.$t('deleteSuccess'))
          this._getChannelList()
        }
      })
    },
    // 点击删除机构头盔权限信息
    _deleteOuHelmetPermiss(row) {
      let param = {
        permissionId: encodeURI(row.permissionsId),
        ouId: this.currentTreeKey.id,
      }
      deleteOuHelmetPermiss(param).then(res => {
        if (res.state === 0) {
          success(this.$t('deleteSuccess'))
          this._getOuHelmetPermiss()
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.changePage()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.changePage()
    },
    // 点击翻页/更换每页条数
    changePage() {
      if (this.activeName === 'wifi') {
        this._getWifiNetwork()
      } else if (this.activeName === 'mailList') {
        this._getContact()
      } else if (this.activeName === 'channel') {
        this._getChannelList()
      } else {
        this._getOuHelmetPermiss()
      }
    },
    // wifi热点基础数据
    basicConfig() {
      this.columns = [
        {
          attrName: 'id',
          label: this.$t('wifiHotspot'),
          sort: 'id',
        },
        {
          attrName: 'password',
          label: this.$t('passwordM'),
          align: 'right',
          sort: 'password',
        },
        {
          attrName: 'priorityDesc',
          label: this.$t('priority'),
          width: '90',
          align: 'center',
          sort: 'priority',
        },

        {
          attrName: 'description',
          label: this.$t('remarks'),
          sort: 'description',
        },
      ]
      this.dateOperation = [
        {
          operateName: this.$t('edit'),
          type: 'edit',
          IsHad: '',
          class: 'editClick',
        },
        {
          operateName: this.$t('delete'),
          type: 'delect',
          IsHad: '',
          class: 'editClick',
        },
      ]
    },
    // 当前机构/用户
    handleNodeClick(data, node) {
      // console.log(data, node)
      this.$refs.dataConfigTree.setCurrentKey(data.id)
      this.defaultId = this.currentTreeKey.id
      this.currentTreeKey = data
      this.handleClick(this.activeName)
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.mechanismData = res.data
          if (this.mechanismData.length > 0) {
            this.currentTreeKey = this.mechanismData[0]
            this.defaultId = this.currentTreeKey.id
            this.$nextTick(() => {
              // 回显默认选择的item 高亮
              this.$refs.dataConfigTree.setCurrentKey(this.defaultId)
            })
          }
          this._getWifiNetwork()
        }
      })
    },
    // 获取 wifi热点数据
    _getWifiNetwork() {
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.currentTreeKey.id,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc
      }
      getWifiNetwork(param).then(res => {
        if (res.state === 0) {
          this.tableData = res.value.content
          this.totalData = res.value.totalElements
        }
      })
    },
    // 获取 通讯录List
    _getContact() {
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.currentTreeKey.id,
      }
      getContact(param).then(res => {
        if (res.state === 0) {
          this.tableData = res.value.content
          this.totalData = res.value.totalElements
        }
      })
    },
    // 获取 频道table
    _getChannelList() {
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.currentTreeKey.id,
      }
      getChannelList(param).then(res => {
        if (res.state === 0) {
          this.tableData = res.data.content
          this.totalData = res.data.totalElements
        }
      })
    },
    // 获取表单所有频道列表
    _getChannels() {
      getChannels().then(res => {
        if (res.state === 0) {
          this.channelOptions = res.data
        }
      })
    },
    searchPermission() {
      // 根据权限名称查询权限信息
      this.currentPage = 1
      this._getOuHelmetPermiss()
    },
    // 获取机构头盔权限信息
    _getOuHelmetPermiss() {
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.currentTreeKey.id,
        permissionsName: this.formInline.permissionsName,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc
      }
      getOuHelmetPermiss(param).then(res => {
        if (res.state === 0) {
          this.tableData = res.data.content
          this.totalData = res.data.totalElements
        }
      })
    },
    // 获取表单所有权限信息
    _getHelmetPermissions() {
      getHelmetPermissions().then(res => {
        if (res.state === 0) {
          console.log(res.data, 'res.data')
          this.helmetPermissOption = res.data
        }
      })
    },
  },
  created() {
    this.basicConfig()
    this.getOusTree()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
  @import '~@/style/mixin.styl'
.base_main
  .common-aside-main
    margin-left 10px
  .pagination
    float right
    margin-top 1%
.serachBox
  margin 10px 0
  text-align center
  border-bottom none
  .el-input
    width 290px !important
.el-tree
  height: 92%;
  overflow: auto;
.custom-tree-node
  flex 1
  display flex
  align-items center
  justify-content space-between
  padding-right 20px
  width 100%
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
  .node-txt
    font-size 16px;/*no*/
.serachLine
  margin 10px 8px 10px 8px
  display flex
  align-items center
  justify-content center
  >>>.el-input__inner
    border 0px !important
    height 36px;/*no*/
    line-height 36px;/*no*/
   /deep/.el-input
    width 180px !important
  .serachBtn
    margin-left 10px
    padding: 10px 20px; /* no */
.el-select
  width 200px; /* no */
.el-select-dropdown
  min-width 90px !important
  color #111111
  .el-select-dropdown__item
    text-align center
// >>>.add-btn
//   span
//     display flex
//     align-items: cneter
.help_icon
  display: inline-block;
  float left
  width 16px;
  height 16px;
  margin-right 3px
>>> .el-tooltip__popper
  p
    line-height 30px
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.el-select-dropdown
  color #fff
  min-width 90px !important
>>>.el-popper
 width 315px!important
.bg-contain .common-table-cnt /deep/ .el-table {
  height: 590px !important
}
.common-blue-contain
  .el-pagination
    margin-top 18px
</style>
